// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tooltip-popper-item{background-color:#666!important}.tooltip-popper-item .popper__arrow:after{border-top-color:#666!important}", ""]);
// Exports
module.exports = exports;
